"use client"

import { useLanguage } from "@/contexts/language-context"
import { translations, type TranslationKey } from "@/translations"

/**
 * `const { t, language } = useTranslation()` — `t('some.key', { name })`
 * substitutes every `{name}` placeholder in the string.
 *
 * `language` is what the date/number helpers in lib/locale.ts take, so a
 * component that formats a timestamp needs only this one hook.
 */
export function useTranslation() {
  const { language } = useLanguage()

  const t = (key: TranslationKey, vars?: Record<string, string | number>): string => {
    let str = translations[language][key]
    if (vars) {
      for (const [name, value] of Object.entries(vars)) {
        str = str.split(`{${name}}`).join(String(value))
      }
    }
    return str
  }

  return { t, language }
}
